import { Chess, PAWN, QUEEN, ROOK } from "@chesshotel/chess";
import { ChessTermType, TermAction, } from "@chesshotel/types";
import { getFen, ranks, uci2move } from "./util.js";
import { isValidFenMove } from "./tactics/util.js";
function isOpenFile(fen, file) {
    const chess = new Chess(fen);
    const squares = ranks.map((rank) => file + rank);
    for (const square of squares) {
        const piece = chess.get(square);
        if (piece && piece.type === PAWN) {
            return false;
        }
    }
    return true;
}
function detectOpenFile(fen, moveStr) {
    const chess = new Chess(fen);
    const moveResult = chess.move(uci2move(moveStr));
    const beforeFile = moveResult.from[0];
    const afterFile = moveResult.to[0];
    if (beforeFile == afterFile) {
        return null;
    }
    const piece = moveResult.piece;
    if (piece != ROOK && piece != QUEEN) {
        return null;
    }
    const isOpen = isOpenFile(chess.fen(), afterFile);
    const translationKeys = {
        piece: piece,
    };
    if (isOpen) {
        const beforeIsOpen = isOpenFile(fen, beforeFile);
        if (beforeIsOpen) {
            return null;
        }
        return {
            term: ChessTermType.OPEN_FILE,
            move: moveResult,
            translationKeys,
        };
    }
}
export function detectPositiveOpenFile(position, lastPosition) {
    const user = detectOpenFile(lastPosition.fen, position.move);
    if (user) {
        return {
            ...user,
            termAction: TermAction.PERFORM,
        };
    }
}
export function detectNegativeOpenFile(position, lastPosition) {
    const user = detectOpenFile(lastPosition.fen, position.move);
    const best = detectOpenFile(lastPosition.fen, lastPosition.bestMove);
    if (!user && best) {
        return {
            ...best,
            termAction: TermAction.MISS,
        };
    }
    if (user && best) {
        return {
            ...user,
            termAction: TermAction.BETTER_WAY,
        };
    }
    const opponentMove = position.pvMoves[0];
    const userAllow = detectOpenFile(position.fen, opponentMove);
    if (userAllow) {
        const bestFen = getFen(lastPosition.fen, lastPosition.pvMoves[0]);
        const isValid = isValidFenMove(bestFen, opponentMove);
        if (!isValid) {
            return {
                ...userAllow,
                termAction: TermAction.ALLOW,
            };
        }
        const bestAllow = isValid && detectOpenFile(bestFen, opponentMove);
        if (!bestAllow) {
            return {
                ...userAllow,
                termAction: TermAction.ALLOW,
            };
        }
    }
    return null;
}
//# sourceMappingURL=openFile.js.map